import React from "react";
import Input from "../../../components/ui/Input";
import Icon from "../../../components/AppIcon";
import Select from "../../../components/ui/Select";

const SurveyDetailsForm = ({ surveyData, errors, onChange }) => {
  const handleChange = (field, value) => {
    onChange(field, value);
  };

  const phaseOptions = [
    { value: "single", label: "Single Phase" },
    { value: "three", label: "Three Phase" },
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 lg:p-8">
      <div className="flex items-center gap-3 mb-4 md:mb-6">
        <div className="w-10 h-10 rounded-lg bg-secondary/10 flex items-center justify-center">
          <Icon name="FileText" size={20} className="text-secondary" />
        </div>
        <h2 className="text-xl md:text-2xl font-semibold text-foreground">
          Survey Details
        </h2>
      </div>

      <div className="space-y-6">
        {/* Meter Details */}
        <div>
          <h3 className="text-base font-semibold text-foreground mb-4 flex items-center gap-2">
            <Icon name="Gauge" size={16} />
            Meter Details
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="Proposed Rooftop Solar Capacity (kW)"
              type="number"
              placeholder="e.g., 3.0"
              step="0.1"
              value={surveyData.proposedCapacityKw}
              onChange={(e) =>
                handleChange("proposedCapacityKw", e.target.value)
              }
              error={errors.proposedCapacityKw}
              className="w-full"
            />

            <Input
              label="Sanctioned Meter Load (kW)"
              type="number"
              placeholder="e.g., 5.0"
              step="0.1"
              value={surveyData.sanctionedLoadKw}
              onChange={(e) => handleChange("sanctionedLoadKw", e.target.value)}
              error={errors.sanctionedLoadKw}
              className="w-full"
            />

            <Select
              label="Phase Connection"
              placeholder="Select phase connection"
              options={phaseOptions}
              value={surveyData.phaseConnection}
              onChange={handleChange.bind(null, "phaseConnection")}
              error={errors.phaseConnection}
              className="w-full"
            />

            <Input
              label="Lineman Name"
              type="text"
              placeholder="Enter lineman name"
              value={surveyData.linemanName}
              onChange={(e) => handleChange("linemanName", e.target.value)}
              error={errors.linemanName}
              className="w-full"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SurveyDetailsForm;
